import Phaser from "phaser";

export default class Game extends Phaser.Scene {
    constructor() {
        super("game");
    }

    preload() {
        // Create a ball texture using Phaser's Graphics
        const graphics = this.make.graphics({ x: 0, y: 0, add: false });
        graphics.fillStyle(0xffff00, 1); // Yellow color for the ball
        // Draw a circle with radius 16 (texture size: 32x32)
        graphics.fillCircle(16, 16, 16);
        graphics.generateTexture('ball', 32, 32);
    }

    create() {
        // Initialize score and display it
        this.score = 0;
        this.scoreText = this.add.text(16, 16, "Score: 0", { fontSize: "32px", fill: "#FFF" });

        // Create the ball with the generated texture
        this.ball = this.physics.add.sprite(400, 250, 'ball')
            .setCircle(16) // Set circular physics body (radius = 16)
            .setCollideWorldBounds(true) // Bounce off all walls
            .setBounce(1, 1)
            .setVelocity(500, 417); // 3x slower than the previous 5x speed

        // Enable world bounds collision events on the ball's body
        this.ball.body.onWorldBounds = true;
        this.physics.world.on('worldbounds', (body, up, down, left, right) => {
            // If the ball collides with the left wall and the game isn't already failed, trigger "Failed"
            if (body.gameObject === this.ball && left) {
                if (!this.failed) {
                    this.failed = true;
                    this.ball.setVelocity(0, 0);
                    this.add.text(400, 300, "Failed", { fontSize: "64px", fill: "#f00" }).setOrigin(0.5);
                }
            }
        });

        // Create a paddle (rectangle) at position (30, 250)
        this.paddleLeft = this.add.rectangle(30, 250, 50, 100, 0xffffff, 1);
        this.physics.add.existing(this.paddleLeft);
        this.paddleLeft.body.setImmovable(true);
        this.paddleLeft.body.setCollideWorldBounds(true);

        // Set up arrow key input for moving the paddle
        this.cursors = this.input.keyboard.createCursorKeys();

        // Setup collision between the ball and paddle; on collision, update score
        this.physics.add.collider(this.ball, this.paddleLeft, this.handlePaddleCollision, null, this);

        // Flag to indicate if the game is in a "failed" state
        this.failed = false;
    }

    handlePaddleCollision(ball, paddle) {
        // Increase the score and update the text
        this.score += 1;
        this.scoreText.setText("Score: " + this.score);
    }

    update() {
        const paddleSpeed = 5;
        
        // Move the paddle using the up and down arrow keys
        if (this.cursors.up.isDown) {
            this.paddleLeft.y -= paddleSpeed;
        } else if (this.cursors.down.isDown) {
            this.paddleLeft.y += paddleSpeed;
        }

        // Clamp the paddle's y-position so it stays within the scene bounds
        const paddleHalfHeight = this.paddleLeft.height / 2;
        const sceneHeight = this.game.config.height;
        this.paddleLeft.y = Phaser.Math.Clamp(this.paddleLeft.y, paddleHalfHeight, sceneHeight - paddleHalfHeight);

        // Update the paddle's physics body to match its new position
        this.paddleLeft.body.updateFromGameObject();
    }
}
